module.exports = __webpack_public_path__ + "static/media/no-image.3c59cc73.jpg";